document.addEventListener("DOMContentLoaded", () => {

    const buttons = document.querySelectorAll("button[data-tab]");

    buttons.forEach(button => {
        button.addEventListener("click", () => {
            const targetTab = button.getAttribute("data-tab");

            document.querySelector("button[data-tab].active")?.classList.remove("active");
            document.querySelector(".tab-content__item.active")?.classList.remove("active");
            button.classList.add("active");
            document.querySelector(`.tab-content__item[data-tab="${targetTab}"]`)?.classList.add("active");
        });
    });
});